import BaseService from '@/ecm/common/BaseService.js';

class DistributionService {
    baseUrl = 'distributions';
    endDistribution = (distributionsToFinish) => BaseService.delete({ url: `${this.baseUrl}`, data: distributionsToFinish });
    validate = (distributionToken, ObjectID) => BaseService.post({ url: `${this.baseUrl}/validate-document/${distributionToken}/${ObjectID}` });
    reject = (distributionToken, ObjectID, rejectComment) => BaseService.post({ url: `${this.baseUrl}/reject-document/${distributionToken}/${ObjectID}`, data: rejectComment });
    comment = (distributionToken, ObjectID, commentExternal) => BaseService.post({ url: `${this.baseUrl}/add-comment/${distributionToken}/${ObjectID}`, data: commentExternal });
    sign = (distributionToken, ObjectID) => BaseService.post({ url: `${this.baseUrl}/sign-document/${distributionToken}/${ObjectID}` });
    getDistributedDocuments = (distributionToken) => BaseService.get({ url: `${this.baseUrl}/list-distributed-documents/${distributionToken}`, })
    endAllDistributions = () => BaseService.delete({ url: `${this.baseUrl}/end-all-for-user` });
}
export default new DistributionService();
